import {registerPlugin} from "surveylabJsAssets/chart/charts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";
import {Options} from "highcharts";

export class Motivations extends AbstractChart {
    protected allChartOptions(): Options {
        const options: Options = {
            chart: {
                type: 'column',
                polar: true,
                height: 510,
            },
            xAxis: {
                labels: {
                    distance: 39,
                    style: {
                        fontSize: '11px',
                    },
                }
            },
            yAxis: {
                labels: {
                    style: {
                        fontWeight: 'bold',
                    },
                },
                showFirstLabel: false,
                tickPositions: [0, 25, 50, 75, 100],
            },
        }

        return super.mergeOptions(super.allChartOptions(), options);
    }
}

export default function () {registerPlugin(Motivations)}